import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { UserAppletContainerModel } from '../../../../../../models/aggregates/applet-store';
import { GetUserAppletLinksModel } from '../../../../../../models/aggregates/custom/platform/get-user-applet-links.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAppletLinksService extends BaseApiTemplateService<any> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'akaun-ng/user-applet-links';
    this.httpClient = http;
  }

  onInstall(dtoObject: UserAppletContainerModel, apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/install';
    }
    return this.httpClient.post<ApiResponseModel<UserAppletContainerModel>>(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa));
  }

  onMultipleInstall(userAppletContainer: UserAppletContainerModel[], apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/multiple-install';
    }
    return this.httpClient.post<ApiResponseModel<UserAppletContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }

  onUninstall(guid: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/uninstall/' + guid;
    }
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  onAdminInstall(userAppletContainer: UserAppletContainerModel, apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/admin/install';
    }
    return this.httpClient.post<ApiResponseModel<UserAppletContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }

  onMultipleAdminInstall(userAppletContainer: UserAppletContainerModel[], apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/admin/multiple-install';
    }
    return this.httpClient.post<ApiResponseModel<UserAppletContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }

  getUserInstalledApplets(apiVisa: ApiVisa, hostnameValueL: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '?hostname_value=' + hostnameValueL;
    }
    return this.httpClient.get<ApiResponseModel<GetUserAppletLinksModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  onMultipleTenantAdminInstall(tenantCode: string, userAppletContainer: UserAppletContainerModel[], apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/tenant-admin-ep/' + tenantCode +'/multiple-install';
    }
    return this.httpClient.post<ApiResponseModel<UserAppletContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }
}


